import styled from "styled-components";

const UnassignButtonWrapper = styled.div`
  padding-right: 20px;
  position: relative;
`;

export default UnassignButtonWrapper;


// WEBPACK FOOTER //
// ./components/footer/unassign-button/styled.js